import { gql } from '@apollo/client';

const CALL_CENTER_ONLINE_TIME_TRACKING_MUTATION = gql`
  mutation callCenterOnlineTimeTracking($input: CallCenterOnlineTimeTrackingInput) {
    callCenterOnlineTimeTracking(input: $input) {
      isSuccess
      message
    }
  }
`;

export default CALL_CENTER_ONLINE_TIME_TRACKING_MUTATION;
